export default "__VITE_ASSET__BIT$GNd$__"